import React from 'react';
import Input from 'components/common/Input';
import { Card } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

const ProductDescriptions = () => {
 const {
  register,
  formState: { errors }
 } = useFormContext();

 return (
  <Card className="mb-0 bg-transparent border">
   <Card.Body className="fs--1">
    <Input
     type="textarea"
     errors={errors}
     name="shortDescription"
     label={
      <div className="">
       <h5 className="mb-0 text-primary">Descripcion corta</h5>
       <small className="mb-0 fs--1 text-700">
        Utilizada en listados de productos, páginas de categoría, tarjetas de productos o en resultados de búsqueda dentro del
        sitio web. Ayuda a captar la atención del cliente rápidamente
       </small>
      </div>
     }
     formGroupProps={{ className: 'mb-3' }}
     formControlProps={{ ...register('shortDescription'), rows: 2, size: 'sm' }}
    />

    <Input
     type="textarea"
     errors={errors}
     name="description"
     label={
      <div className="">
       <h5 className="mb-0 text-primary">Descripcion</h5>
       <small className="mb-0 fs--1 text-700">
        Encontrada en la página del producto, donde los clientes pueden profundizar para obtener más información antes de tomar
        una decisión de compra.
       </small>
      </div>
     }
     formGroupProps={{ className: 'mb-3' }}
     formControlProps={{ ...register('description'), rows: 6, size: 'sm' }}
    />
   </Card.Body>
  </Card>
 );
};

export default ProductDescriptions;
